import doctorMark from '../../../Assets/Images/doctor.jpg';
import doctorSarah from '../../../Assets/Images/doctor_background.jpg';
import doctorOmar from '../../../Assets/Images/doctorLoader1.png';
import certDSD from '../../../Assets/Images/rosheta1.jpg';
import certImplant from '../../../Assets/Images/rosheta2.jpg';
import certBone from '../../../Assets/Images/stars.jpg';
import certDigital from '../../../Assets/Images/banner_image.jpg';
import certAligners from '../../../Assets/Images/patient5.jpg';
import certPediatric from '../../../Assets/Images/patient1.avif';

const L = (en, ar) => ({ en, ar });

export const doctors = [
	{
		id: 1,
		image: doctorMark,
		name: L('Dr. Mark Atef', 'د. مارك عاطف'),
		specialty: L('Dental Implant & Cosmetic Dentistry', 'زراعة الأسنان وطب الأسنان التجميلي'),
		age: 38,
		experienceYears: 15,
		rating: 4.9,
		brief: L(
			'A passionate dentist and the founder of the clinic, dedicated to restoring confident smiles using the latest digital implant and cosmetic dentistry techniques with a patient-first approach.',
			'طبيب أسنان شغوف ومؤسس العيادة، متخصص في استعادة الابتسامة الواثقة باستخدام أحدث تقنيات زراعة الأسنان والتجميل الرقمي بأسلوب يضع المريض أولاً.'
		),
		study: L(
			'Ph.D. in Dental Implantology — Cairo University, 2010',
			'دكتوراه في زراعة الأسنان — جامعة القاهرة، 2010'
		),
		achievements: [
			L(
				'3000+ successful implant and cosmetic procedures',
				'+3000 عملية ناجحة في زراعة وتجميل الأسنان'
			),
			L('International speaker at implantology conferences', 'متحدث دولي في مؤتمرات زراعة الأسنان'),
			L('Certified DSD (Digital Smile Design) specialist', 'معتمد في تصميم الابتسامة الرقمي (DSD)'),
			L('Member of the Egyptian Dental Association', 'عضو نقابة أطباء الأسنان المصرية')
		],
		careerPath: [
			{ period: '2010 - 2013', role: L('Resident Dentist — National Dental Center', 'طبيب مقيم — المركز القومي لطب الأسنان') },
			{ period: '2013 - 2016', role: L('Implantologist — Smile Care Clinics', 'أخصائي زراعة — عيادات سمايل كير') },
			{ period: '2016 - 2020', role: L('Senior Implant Surgeon', 'جراح زراعة أسنان أول') },
			{ period: '2020 - Present', role: L('Founder & Medical Director of the Clinic', 'مؤسس ومدير طبي للعيادة') }
		],
		certificates: [
			{ id: 'c1', title: L('DSD Master Certification — 2017', 'شهادة أستاذية DSD — 2017'), year: 2017, file: certDSD },
			{ id: 'c2', title: L('Straumann Implantology Diploma — 2015', 'دبلومة زراعة ستراومان — 2015'), year: 2015, file: certImplant },
			{ id: 'c3', title: L('Advanced Bone Grafting Workshop — 2019', 'دورة تطعيم العظام المتقدم — 2019'), year: 2019, file: certBone },
			{ id: 'c4', title: L('Digital Smile Design International — 2016', 'التصميم الرقمي للابتسامة الدولي — 2016'), year: 2016, file: certDigital }
		]
	},
	{
		id: 3,
		image: doctorOmar,
		name: L('Dr. Omar Khaled', 'د. عمر خالد'),
		specialty: L('Pediatric Dentistry', 'طب أسنان الأطفال'),
		age: 34,
		experienceYears: 10,
		rating: 4.7,
		brief: L(
			'A gentle and child-friendly pediatric dentist who makes dental visits fun and stress-free, focusing on prevention and early treatment of kids\' teeth.',
			'طبيب أسنان أطفال ودود ولطيف يجعل زيارة طبيب الأسنان ممتعة وخالية من التوتر، مع التركيز على الوقاية والعلاج المبكر لأسنان الأطفال.'
		),
		study: L(
			"Master's in Pediatric Dentistry — Ain Shams University, 2016",
			'ماجستير طب أسنان الأطفال — جامعة عين شمس، 2016'
		),
		achievements: [
			L('Certified in conscious sedation for children', 'معتمد في التخدير الواعي للأطفال'),
			L('4000+ child patient visits', '+4000 زيارة لمريض من الأطفال'),
			L('Keynote speaker in pediatric dentistry forums', 'متحدث رئيسي في منتديات طب أسنان الأطفال')
		],
		careerPath: [
			{ period: '2016 - 2019', role: L('Pediatric Dentistry Resident', 'مقيم طب أسنان الأطفال') },
			{ period: '2019 - 2021', role: L('Pediatric Dentist — Kids Smile Center', 'طبيب أسنان أطفال — مركز ابتسامة الأطفال') },
			{ period: '2021 - Present', role: L('Head of Pediatric Dentistry Department', 'رئيس قسم طب أسنان الأطفال') }
		],
		certificates: [
			{ id: 'c1', title: L('Pediatric Conscious Sedation Certificate — 2020', 'شهادة التخدير الواعي للأطفال — 2020'), year: 2020, file: certPediatric },
			{ id: 'c2', title: L('Early Caries Management Course — 2018', 'دورة إدارة التسوس المبكر — 2018'), year: 2018, file: certDSD }
		]
	}
];